import { provideHttpClient, withFetch, withInterceptorsFromDi, ɵwithHttpTransferCache } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer
} from '@angular/core';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { RouterModule, provideRouter, withComponentInputBinding, withInMemoryScrolling, Router } from '@angular/router';

import { CHANNEL_LINK_TRANSLATIONS } from '@usheru-hff/sdk/channel';
import {
  provideGlobalErrorHandler,
  providePostBootstrapVersionLogger,
  provideSwiperLoader
} from '@usheru-hff/shared/utils';
import { provideLazyToast } from '@usheru-hff/ui/notfication';

import { AppModule } from './app.module';
import { APP_ROUTES } from './app.routes';
import { currentGitVersion } from './version';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { TraceService } from '@sentry/angular';
import { provideUshTheme } from '@usheru-hff/ui/theme';

export const appConfig: ApplicationConfig = {
  providers: [
    provideSwiperLoader(),
    provideClientHydration(withEventReplay(), withHttpTransferCacheOptions({ includeRequestsWithAuthHeaders: true })),
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      }),
      withComponentInputBinding()
    ),

    importProvidersFrom(AppModule),
    provideUshTheme(),

    provideLazyToast(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    providePostBootstrapVersionLogger(currentGitVersion),
    importProvidersFrom(NgProgressRouterModule),

    provideGlobalErrorHandler(true),
    {
      provide: TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    {
      provide: CHANNEL_LINK_TRANSLATIONS,
      useValue: {
        enCasa: $localize`:@@public.header.link.channel.enCasa:En Casa`,
        enCines: $localize`:@@public.header.link.channel.enCines:`
      }
    }
  ]
};
